import React, {useState} from 'react';
import cx from 'classnames';
import './TabSwitch.scss';

function FoMoTab({tabData, onClick, isActive}) {
  const {header, id} = tabData;

  return (
    <div
      role='tab'
      id={`tab-${id}`}
      aria-selected={isActive ? 'true' : 'false'}
      aria-controls={`panel-${id}`}
      tabIndex='0'
      onClick={onClick}
      className={cx('ppq--web--tab-switch--tab', {'ppq--web--tab-switch--tab--active': isActive})}
    >
      {header}
    </div>
  );
}

function TabSwitch({tabs}) {
  const [selectedTab, setSelectedTab] = useState(tabs?.[0] || {});

  const buttons = tabs.map((currentTab) => {
    const handleTabClick = () => {
      setSelectedTab(currentTab);
    };

    return <FoMoTab key={currentTab.id} tabData={currentTab} onClick={handleTabClick} isActive={selectedTab.id === currentTab.id} />;
  });

  return (
    <div className='ppq--web--tab-switch'>
      <div role='tablist' aria-label='Offer Tabs' className='ppq--web--tab-switch--header'>
        {buttons}
      </div>
      <div role='tabpanel' aria-labelledby={`tab-${selectedTab.id}`} id={`panel-${selectedTab.id}`}>
        {selectedTab?.content}
      </div>
    </div>
  );
}

export default TabSwitch;
